export default __webpack_public_path__ + "static/media/apostar_icons_white_benutzer_anlegen.8796256c.svg";